<template>
  <AdminModal :title="`${row.plan ? 'Cambiar plan' : 'Asignar plan'} · ${row.name}`" @close="$emit('close')">
    <form id="plan-assign-form" @submit.prevent="submit">
      <p v-if="!plans.length" class="ad-note ad-note--warn">No hay planes disponibles. Crea uno en la sección "Planes" de esta página.</p>
      <div v-else class="plans" role="radiogroup" aria-label="Planes">
        <label v-for="p in plans" :key="p.id" class="plan-opt" :class="{ 'plan-opt--on': planId === p.id }">
          <input v-model="planId" type="radio" name="plan" :value="p.id" />
          <span class="plan-opt__name">{{ p.name }}</span>
          <span class="ad-mono">{{ money(p.monthlyPrice) }} / mes</span>
        </label>
      </div>
      <p v-if="row.plan" class="ad-hint" style="margin-bottom: 12px">
        Plan actual: {{ row.plan }} ({{ money(row.monthlyAmount) }}). El nuevo precio se cobra desde el siguiente cobro.
      </p>
      <div class="ad-field">
        <label for="plan-next">{{ row.nextBillingAt ? 'Fecha del próximo cobro (opcional)' : 'Fecha del primer cobro' }}</label>
        <input id="plan-next" v-model="nextBillingAt" type="date" class="ad-input" :required="!row.nextBillingAt" />
        <span v-if="row.nextBillingAt" class="ad-hint">Vacío = se conserva {{ formatDate(row.nextBillingAt) }}.</span>
      </div>
      <p v-if="error" class="ad-error">{{ error }}</p>
    </form>
    <template #footer>
      <button type="button" class="ad-btn ad-btn--ghost" @click="$emit('close')">Cancelar</button>
      <button type="submit" form="plan-assign-form" class="ad-btn ad-btn--primary" :disabled="busy || !planId || (planId === row.planId && !nextBillingAt)">
        {{ busy ? 'Guardando…' : 'Guardar' }}
      </button>
    </template>
  </AdminModal>
</template>

<script setup>
import { ref } from 'vue'
import AdminModal from './AdminModal.vue'
import { assignPlan } from '@/services/superadmin'
import { errorText, formatDate, money, todayInput } from './adminFormat'

const props = defineProps({ row: { type: Object, required: true }, plans: { type: Array, required: true } })
const emit = defineEmits(['close', 'done'])

const planId = ref(props.row.planId || '')
const nextBillingAt = ref(props.row.nextBillingAt ? '' : todayInput())
const busy = ref(false)
const error = ref('')

async function submit() {
  busy.value = true
  error.value = ''
  try {
    await assignPlan(props.row.id, planId.value, nextBillingAt.value || undefined)
    emit('done')
  } catch (err) {
    error.value = errorText(err)
  } finally {
    busy.value = false
  }
}
</script>

<style scoped>
.plans { display: flex; flex-direction: column; gap: 8px; margin-bottom: 12px; }
.plan-opt {
  display: flex; align-items: center; gap: 10px; padding: 10px 12px; border: 1px solid #d5dbe6; border-radius: 8px; cursor: pointer;
}
.plan-opt--on { border-color: #3b82f6; background: #eff6ff; }
.plan-opt__name { flex: 1; font: 500 13px Inter, sans-serif; color: #1e3a5f; }
</style>